var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createContext } from "react";
import { addDays, addWeeks, addMonths, addYears, nextMonday, nextFriday, startOfMonth, format, } from "date-fns";
import { fr } from "date-fns/locale";
import moment from "moment";
import "moment/locale/fr";
import { t } from "i18next";
import { Slot } from "@/utils/types/layout";
import { PUBLIC_URL } from "@/utils/const";
moment.locale("fr");
var createComponent = function (type, label, groups) {
    // Create
    return {
        type: type,
        label: label,
        groups: groups,
    };
};
export { createComponent };
export function decodeHtmlCharCodes(text) {
    var entities = [
        ["amp", "&"],
        ["apos", "'"],
        ["#x27", "'"],
        ["#x2F", "/"],
        ["#039", "'"],
        ["#39", "'"],
        ["#47", "/"],
        ["lt", "<"],
        ["gt", ">"],
        ["nbsp", " "],
        ["quot", '"'],
    ];
    for (var i = 0, max = entities.length; i < max; ++i)
        text = text.replace(new RegExp("&" + entities[i][0] + ";", "g"), entities[i][1]);
    return text;
}
// Global context for all layout detailview
export var FormSettingsContext = createContext({});
/**
 * Style of selected field or layout
 * @param {*} isSelected
 */
export var getLayoutStyle = function (isSelected) { return ({
    border: isSelected ? "2px solid blue" : "none",
}); };
/**
 * Default value of component layout settings
 */
export var defaultSettings = {
    target: 0,
    component: { settings: "" },
    selected: "",
    type: "",
    parentId: { id: "" },
    isDirty: false,
    newLayout: null,
    currentComponent: {},
    clipBoard: "",
    undoStack: [],
    redoStack: [],
};
/**
 * Update Layout or field
 * @param nestedProp
 * @param compareKey
 * @param compareId
 * @param arr
 * @param settings
 * @returns
 */
export var updateSettingsComponent = function (nestedProp, compareKey, compareId, arr, settings) {
    return arr.filter(function (o, index) {
        var keep = o[compareKey] !== compareId;
        if (keep) {
            if (o[nestedProp]) {
                o[nestedProp] = updateSettingsComponent(nestedProp, compareKey, compareId, o[nestedProp], settings);
            }
        }
        else {
            o.settings =
                /*(settings.component.settings && settings.component.settings) ||*/
                settings.currentComponent.settings &&
                    settings.currentComponent.settings;
        }
        return arr;
    });
};
/**
 * Remove layout or field
 * @param list the component array
 * @param id the id to remove
 * @returns
 */
export var removeComponent = function (list, id) {
    return list
        .map(function (item) {
        return __assign({}, item);
    })
        .filter(function (item) {
        if ("components" in item) {
            item.components = removeComponent(item.components, id);
        }
        return item.id !== id;
    });
};
/**
 * Move component to first
 * @param {*} components
 * @param {*} component
 */
export function moveFirstComponent(components, component) {
    var i = components.findIndex(function (e) { return e.id === component.id; });
    if (i === -1) {
        return;
    }
    var index = components.findIndex(function (c) { return c.id === component.id; });
    components.splice(index, 1);
    components.unshift(component);
    return components;
}
/**
 * Move component to last
 * @param {*} components
 * @param {*} component
 */
export var moveLastComponent = function (components, component) {
    var i = components.findIndex(function (e) { return e.id === component.id; });
    if (i === -1) {
        return;
    }
    var index = components.findIndex(function (c) { return c.id === component.id; });
    components.splice(index, 1);
    components.push(component);
    return components;
};
/**
 * Move component up
 * @param {*} components
 * @param {*} component
 */
export var moveUpComponent = function (components, component) {
    var i = components.findIndex(function (e) { return e.id === component.id; });
    if (i === -1) {
        return;
    }
    var index = components.findIndex(function (c) { return c.id === component.id; });
    components.splice(index, 1);
    components.splice(Math.max(index - 1, 0), 0, component);
};
/**
 * Move component down
 * @param {*} components
 * @param {*} component
 */
export var moveDownComponent = function (components, component) {
    var i = components.findIndex(function (e) { return e.id === component.id; });
    if (i === -1) {
        return;
    }
    var index = components.findIndex(function (c) { return c.id === component.id; });
    components.splice(index, 1);
    components.splice(Math.min(index + 1, Math.max(0, components.length)), 0, component);
};
/**
 * Add component into a list
 * @param {*} list : the array layout
 * @param {*} id : parent id
 * @param {*} newComponent : the new component
 */
export var addComponent = function (list, id, newComponent) {
    var result = list.map(function (row) {
        if (row.components && row.components.length) {
            var components = addComponent(row.components, id, newComponent);
            components.filter(function (item) {
                if (item.id === id) {
                    return __assign(__assign({}, item), { components: item.components.push(newComponent) });
                }
            });
            return __assign(__assign({}, row), { components: components });
        }
        else {
            return __assign({}, row);
        }
    });
    return result;
};
/**
 * Recursively transform values within a data structure.
 *
 * @param {any} arr - The data structure to transform.
 * @param {any} parentId - The parentId of field.
 * @param {any} newComponent - The new component.
 * @param {any} isLayout - Is layout or not.
 * @returns {any}  - The new modified component layout.
 */
export var updateLayoutComponent = function (arr, parentId, newComponent, isLayout) {
    var result = arr.map(function (row) {
        if (row.components && row.components.length) {
            var components = updateLayoutComponent(row.components, parentId, newComponent, isLayout);
            components.filter(function (item) {
                if (item.id === parentId) {
                    return __assign(__assign({}, row), { components: newComponent });
                }
            });
            return __assign(__assign({}, row), { components: components });
        }
        else {
            return __assign({}, row);
        }
    });
    return result;
};
/**
 * Update tab component
 * @param {*} list
 * @param {*} id
 * @param {*} tabComp
 */
export var updateTabComponent = function (list, tabId, tabComp) {
    var result = list.map(function (row) {
        if (row && row.components && row.components.length) {
            var components = updateTabComponent(row.components, tabId, tabComp);
            components.filter(function (item) {
                if (item.id === tabId) {
                    return __assign(__assign({}, item), { settings: tabComp.settings, components: item.components.push(tabComp.components) });
                }
            });
            return __assign(__assign({}, row), { components: components });
        }
        else {
            return __assign({}, row);
        }
    });
    return result;
};
/**
 * Prend l'index de component niveau 1 du Tab avec id du fils
 * @param {*} tabLayout
 * @param {*} layoutId
 * @returns index du component
 */
export var findTabComponentIndex = function (tabLayout, layoutId) {
    var childIndex = tabLayout.components.findIndex(function (elt1) {
        if (elt1 && elt1.id === layoutId) {
            return true;
        }
        else if (elt1 && elt1.components !== undefined) {
            var nextLevel = findTabComponentIndex(elt1, layoutId);
            return nextLevel > -1;
        }
        return false;
    });
    return childIndex;
};
/**
 * Prend l'index de component niveau 1 du Tab avec l'id de l'etc-field
 * @param {*} arr
 * @param {*} idc
 * @returns index du component
 */
export function findParent(arr, idc, parent) {
    if (parent === void 0) { parent = 0; }
    var found = false;
    for (var _i = 0, _a = arr.components; _i < _a.length; _i++) {
        var elem = _a[_i];
        if (elem.id === idc) {
            found = true;
            return { id: arr.id, type: arr.type, components: arr.components };
        }
        if (elem.components && elem.components.length > 0 && !found) {
            var foundParentNode = findParent(elem, idc, arr.components);
            if (foundParentNode)
                return foundParentNode;
        }
    }
}
/**
 * Layouts list
 */
export var layoutList = [
    { name: "tab", label: "Tab" },
    { name: "panel", label: "Panel" },
    { name: "layout-rows", label: "Layout rows" },
    {
        name: "layout-columns",
        label: "Layout columns",
    },
    { name: "etc-field", label: "Champ de module" },
    { name: "header", label: "En tête" },
    { name: "etc-widget", label: "Widget" },
];
/**
 * Create state snapshot
 * @param {*} settings
 * @returns
 */
export var createStateSnapshot = function (settings) {
    return {
        target: settings.target,
        component: settings.component,
        selected: settings.selected,
        newLayout: settings.newLayout,
        currentComponent: settings.currentComponent,
        type: settings.type,
        clipBoard: settings.clipBoard,
        parentId: settings.parentId,
    };
};
/**
 * Restore state from a snapshot
 * @param {*} state
 * @param {*} settings
 */
export var restoreStateSnapshot = function (settings) {
    var state = {};
    state.target = settings.target;
    state.component = settings.component;
    state.selected = settings.selected;
    state.newLayout = settings.newLayout;
    state.currentComponent = settings.currentComponent;
    state.type = settings.type;
    state.clipBoard = settings.clipBoard;
    state.parentId = settings.parentId;
    return state;
};
/**
 * Format spacign styles
 * @param {*} styles
 */
export var getStyleSpacing = function (styles) {
    var spacing = styles.spacing || {};
    var margin = spacing.margin || {};
    var padding = spacing.padding || {};
    var s = {
        marginTop: margin.top ? margin.top.replace(" ", "") : "initial",
        marginRight: margin.right ? margin.right.replace(" ", "") : "initial",
        marginBottom: margin.bottom ? margin.bottom.replace(" ", "") : "initial",
        marginLeft: margin.left ? margin.left.replace(" ", "") : "initial",
        paddingTop: padding.top ? padding.top.replace(" ", "") : "initial",
        paddingRight: padding.right ? padding.right.replace(" ", "") : "initial",
        paddingBottom: padding.bottom ? padding.bottom.replace(" ", "") : "initial",
        paddingLeft: padding.left ? padding.left.replace(" ", "") : "initial",
    };
    return s;
};
/**
 * Get style color for etc-field label
 */
export var getColorStyle = function (styles) {
    var scolor = styles.color || {};
    var background = scolor.background || {};
    var label = scolor.label || {};
    var border = scolor.border || {};
    var s = {
        background: background || "transparent",
        border: "".concat(border, " solid 1px") || "transparent",
        color: label || "transparent",
    };
    return s;
};
/**
 * Scroll to element
 * @param refs
 */
export var scrollToEl = function (refs) {
    refs.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
    });
};
export var convertTo24HourFormat = function (timeString) {
    var _a = timeString
        .match(/(\d{1,2}:\d{2})([ap]m)/i)
        .slice(1, 3), time = _a[0], period = _a[1];
    var _b = time.split(":").map(Number), hours = _b[0], minutes = _b[1];
    if (period.toLowerCase() === "pm" && hours !== 12) {
        hours += 12;
    }
    else if (period.toLowerCase() === "am" && hours === 12) {
        hours = 0;
    }
    var formattedHours = String(hours).padStart(2, "0");
    var formattedMinutes = String(minutes).padStart(2, "0");
    return "".concat(formattedHours, ":").concat(formattedMinutes);
};
export var parseRelativeDate = function (relativeDate) {
    var currentDate = new Date();
    switch (relativeDate) {
        case "now":
            return currentDate;
        case "-1 day":
            return addDays(currentDate, -1);
        case "+1 day":
            return addDays(currentDate, 1);
        case "+1 week":
            return addWeeks(currentDate, 1);
        case "next monday":
            return nextMonday(currentDate);
        case "next friday":
            return nextFriday(currentDate);
        case "+2 weeks":
            return addWeeks(currentDate, 2);
        case "+1 month":
            return addMonths(currentDate, 1);
        case "first day of next month":
            return startOfMonth(addMonths(currentDate, 1));
        case "+3 months":
            return addMonths(currentDate, 3);
        case "+6 months":
            return addMonths(currentDate, 6);
        case "+1 year":
            return addYears(currentDate, 1);
        default:
            throw new Error("Valeur relative non support\u00E9e: ".concat(relativeDate));
    }
};
export var parseDatetimeDefault = function (dateString) {
    var _a;
    if (!dateString) {
        return;
    }
    var parts = dateString === null || dateString === void 0 ? void 0 : dateString.split("&");
    var relativeDateValue = parts && parseRelativeDate(parts[0]);
    var time = parts && convertTo24HourFormat(parts[1]);
    var dateDefault = time && new Date(relativeDateValue);
    var _b = time && ((_a = time.split(":")) === null || _a === void 0 ? void 0 : _a.map(Number)), hours = _b[0], minutes = _b[1];
    dateDefault && (dateDefault === null || dateDefault === void 0 ? void 0 : dateDefault.setHours(hours));
    dateDefault && (dateDefault === null || dateDefault === void 0 ? void 0 : dateDefault.setMinutes(minutes));
    dateDefault && (dateDefault === null || dateDefault === void 0 ? void 0 : dateDefault.setSeconds(0));
    dateDefault && (dateDefault === null || dateDefault === void 0 ? void 0 : dateDefault.setMilliseconds(0));
    return dateDefault.toString();
};
export function convertTimeToText(timeString) {
    var _a = timeString.split(":").map(Number), hours = _a[0], minutes = _a[1];
    var days = Math.floor(hours / 24);
    var remainingHours = hours % 24;
    var result = "";
    if (days > 0) {
        result += "".concat(days, " day").concat(days > 1 ? "s" : "", " ");
    }
    if (remainingHours > 0) {
        result += "".concat(remainingHours, " hour").concat(remainingHours > 1 ? "s" : "", " ");
    }
    if (minutes > 0) {
        result += "".concat(minutes, " minute").concat(minutes > 1 ? "s" : "");
    }
    return result.trim();
}
export function convertSecondsToHHMM(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var formattedHours = hours.toString().padStart(2, "0");
    var formattedMinutes = minutes.toString().padStart(2, "0");
    return "".concat(formattedHours, ":").concat(formattedMinutes);
}
export function timeStringToSeconds(timeString) {
    var _a = timeString.split(":").map(Number), hours = _a[0], minutes = _a[1];
    var seconds = hours * 3600 + minutes * 60;
    return seconds;
}
export function formatDateString(dateTimeFormat) {
    if (!dateTimeFormat)
        return "";
    return dateTimeFormat
        .replace("m", "MM")
        .replace("Y", "yyyy")
        .replace("d", "DD")
        .replace("H", "HH")
        .replace("i", "mm")
        .replace("A", "a");
}
export function dateString(dateString) {
    var formatDate = function (dateStr) {
        var date = new Date(dateStr.replace(" ", "T"));
        var formatted = format(date, "dd MMM, HH'h'mm", { locale: fr });
        formatted = formatted.replace(".", "");
        var parts = formatted.split(" ");
        if (parts.length >= 2) {
            //parts[1] = parts[1].toUpperCase();
            parts[1] = parts[1].slice(0, 3).toUpperCase();
        }
        return "".concat(parts[0], " ").concat(parts[1], ", ").concat(parts[2]);
        //return parts.join(" ");
    };
    return formatDate(dateString);
}
export var getPeriodLengthInDays = function (period) {
    switch (period) {
        case "heure":
            return 1 / 24;
        case "jour":
            return 1;
        case "semaine":
            return 7;
        case "mois":
            return 30;
        case "trimestre":
            return 90;
        case "semestre":
            return 180;
        case "année":
            return 365;
        default:
            return 7;
    }
};
export var getLimitDurationInDays = function (limit) {
    switch (limit) {
        case "Les dernières 24h":
            return 1;
        case "Les 2 derniers jours":
            return 2;
        case "Les 7 derniers jours":
            return 7;
        case "Les 30 derniers jours":
            return 30;
        case "Les 90 derniers jours":
            return 90;
        case "Les derniers 6 mois":
            return 180;
        case "La dernière année":
            return 365;
        case "Les 2 dernières années":
            return 730;
        case "Hier":
            return 1;
        case "Avant-hier":
            return 1;
        case "La semaine dernière":
            return 7;
        case "Le mois dernier":
            return 30;
        case "Le trimestre dernier":
            return 90;
        case "Le semestre dernier":
            return 180;
        case "L'année dernière":
            return 365;
        default:
            return 0;
    }
};
export var calculateRanges = function (period, limit) {
    var today = moment();
    var periodLength = getPeriodLengthInDays(period);
    var limitDays = getLimitDurationInDays(limit);
    // Cas spéciaux : hier / avant-hier
    if (limit === "Hier") {
        var day = today.clone().subtract(1, "day");
        return [{ from: day.format("YYYY-MM-DD"), to: day.format("YYYY-MM-DD") }];
    }
    if (limit === "Avant-hier") {
        var day = today.clone().subtract(2, "day");
        return [{ from: day.format("YYYY-MM-DD"), to: day.format("YYYY-MM-DD") }];
    }
    if (limit === "à date") {
        var from = today.clone().startOf("isoWeek");
        var to = today.clone().endOf("isoWeek");
        return [{ from: from.format("YYYY-MM-DD"), to: to.format("YYYY-MM-DD") }];
    }
    var numberOfPeriods = Math.floor(limitDays / periodLength);
    var newRanges = [];
    for (var i = numberOfPeriods; i >= 1; i--) {
        var baseDate = today.clone().subtract(i * periodLength, "days");
        var from = baseDate.clone();
        var to = baseDate.clone();
        switch (period) {
            case "heure":
                from = baseDate.clone().startOf("hour");
                to = baseDate.clone().endOf("hour");
                break;
            case "jour":
                from = baseDate.clone().startOf("day");
                to = baseDate.clone().endOf("day");
                break;
            case "semaine":
                from = baseDate.clone().startOf("isoWeek");
                to = baseDate.clone().endOf("isoWeek");
                break;
            case "mois":
                from = baseDate.clone().startOf("month");
                to = baseDate.clone().endOf("month");
                break;
            case "trimestre":
                from = baseDate.clone().startOf("quarter");
                to = baseDate.clone().endOf("quarter");
                break;
            case "semestre":
                var semester = baseDate.month() < 6 ? 0 : 6;
                from = baseDate.clone().month(semester).startOf("month");
                to = baseDate
                    .clone()
                    .month(semester + 5)
                    .endOf("month");
                break;
            case "année":
                from = baseDate.clone().startOf("year");
                to = baseDate.clone().endOf("year");
                break;
        }
        newRanges.push({
            from: from.format("YYYY-MM-DD"),
            to: to.format("YYYY-MM-DD"),
        });
    }
    return newRanges;
};
export var periods = [
    "heure",
    "jour",
    "semaine",
    "mois",
    "trimestre",
    "semestre",
    "année",
];
export var limits = [
    "Les dernières 24h",
    "Les 2 derniers jours",
    "Les 7 derniers jours",
    "Les 30 derniers jours",
    "Les 90 derniers jours",
    "Les derniers 6 mois",
    "La dernière année",
    "Les 2 dernières années",
    "Hier",
    "Avant-hier",
    "La semaine dernière",
    "Le mois dernier",
    "Le trimestre dernier",
    "Le semestre dernier",
    "L'année dernière",
];
export var get_current_language = function () {
    return localStorage.getItem("i18nextLng") || null;
};
export var limitOptionsByPeriod = {
    heure: ["Les dernières 24h"],
    jour: ["Les 2 derniers jours", "Les 7 derniers jours", "Hier", "Avant-hier"],
    semaine: ["Les 30 derniers jours", "La semaine dernière"],
    mois: [
        "Les 90 derniers jours",
        "Les derniers 6 mois",
        "Le mois dernier",
        "Le trimestre dernier",
    ],
    trimestre: ["Le trimestre dernier", "Les derniers 6 mois"],
    semestre: ["Le semestre dernier", "L'année dernière"],
    année: ["L'année dernière", "Les 2 dernières années"],
};
export var numberSlotLimit = 4;
export var allSizeOptions = [
    { label: "petit", value: 1 },
    { label: "moyen", value: 2 },
    { label: "grand", value: 3 },
    { label: "tres grand", value: 4 },
];
/**
 * Fonction dynamique pour traduire un label avec fallback.
 * - Essaie de traduire dans le namespace du module donné
 * - Si la traduction échoue (contient encore LBL_), on essaie avec le label comme son namespace,
 * - Si la traduction échoue encore, on essaie dans "common"
 * - Si ça échoue encore, on retourne directement le string brut
 */
export var translateString = function (str, mod) {
    var _a;
    var strKey;
    //On définit le label
    if (mod === "common") {
        strKey = "app.LBL_".concat(str === null || str === void 0 ? void 0 : str.toString().toUpperCase());
    }
    else {
        strKey = "LBL_".concat(str === null || str === void 0 ? void 0 : str.toString().toUpperCase());
    }
    // --- Essai 1 : namespace module donnée ---
    var result = t(strKey, { ns: mod });
    if (result.includes("LBL_")) {
        // --- Essai 2 : namespace moduleMod qu'on crée avec str  (ex: "Accounts") ---
        var moduleMod = ((_a = str === null || str === void 0 ? void 0 : str.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + (str === null || str === void 0 ? void 0 : str.slice(1));
        result = t(strKey, { ns: moduleMod });
        if (result.includes("LBL_")) {
            // --- Essai 3 : namespace common ---
            var commonResult = t("app.LBL_".concat(str === null || str === void 0 ? void 0 : str.toString().toUpperCase()), { ns: "common" });
            result = commonResult.includes("LBL_") ? str : commonResult;
        }
    }
    return result;
};
export var smallSlot = [
    Slot.HEADER_START,
    Slot.HEADER_CENTER,
    Slot.HEADER_END,
    Slot.FOOTER_START,
    Slot.FOOTER_CENTER,
    Slot.FOOTER_END,
    Slot.MENU_NORTH,
];
export function stripBasename(pathname) {
    var base = PUBLIC_URL === "/" ? "" : PUBLIC_URL;
    return pathname.startsWith(base)
        ? pathname.slice(base.length) || "/"
        : pathname;
}
var widgetSizesMap = {
    "widget/favorite": [
        { size: 1, labelKey: "LBL_WIDGET_S", minHeight: "min-h-4" },
        { size: 2, labelKey: "LBL_WIDGET_M", minHeight: "min-h-8" },
        { size: 3, labelKey: "LBL_WIDGET_L", minHeight: "min-h-10" },
    ],
    // add new widget types here
};
export function getDisplayWidgetSizes(widgetType) {
    if (!widgetType)
        return null;
    return widgetSizesMap[widgetType] || null;
}
var widgetAvailabilityMap = {
    "widget/weather": {
        canBeInSmallSlot: false,
        canBeInBigSlot: true,
        allowedSlots: [],
    },
    // add more special widgets here
};
export function isWidgetAvailableArea(widgetType) {
    var defaultAvailability = {
        canBeInSmallSlot: true,
        canBeInBigSlot: true,
        allowedSlots: __spreadArray([], smallSlot, true),
    };
    if (!widgetType)
        return defaultAvailability;
    return widgetAvailabilityMap[widgetType] || defaultAvailability;
}
